import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  editingStage: null,
};

const timelineStagesSlice = createSlice({
  name: "timelineStages",
  initialState,
  reducers: {
    setStages(state, action) {
      state.items = action.payload || [];
    },
    setEditingStage(state, action) {
      state.editingStage = action.payload || null;
    },
  },
});

export const { setStages, setEditingStage } = timelineStagesSlice.actions;
export default timelineStagesSlice.reducer;
